<template>
    <div class="guangxi">
        <h2>广西疫情情况</h2>
        <div class="update-time" v-if="asTime">{{asTime}}24时（北京时间）数据统计</div> 
        <div class="sink-state">
            <ul>
                <li v-for="(item,index) in diseaseList" :key="index">
                    <div :class="`num s${index + 1}`">{{item.description}}</div>
                    <div class="state">{{item.title}}</div>
                </li>
            </ul>
        </div>  
        <!-- <div class="gx-map">
            <Maps></Maps>
        </div>   
        <div class="detail">
            <a href="https://v.gxnews.com.cn/zt/2020yq" target="_blank">点击了解详细数据</a>
        </div>    -->
    </div>
</template>

<script>
import HighCharts from 'highcharts'
import jsonp from 'jsonp'
import Maps from './maps.vue'

export default{
    name: 'gx',
    data(){
        return{
            diseaseList: [],
            asTime: ''    
        }
    },
    mounted(){
        jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=50920&start=1&limit=20', null, (err, data) => {
            if (err) {
                console.error(err.message);
            } else {
                this.diseaseList = data;
            }
        })
        jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=50919&start=0&limit=20', null, (err, data) => {
            if (err) {
                console.error(err.message);
            } else {
                this.asTime = data[14].title;
            }
        })
    },
    components:{
        Maps
    }
}
</script>

<style lang="less" scoped>
    .guangxi{
        padding: 0.5rem 0.3rem 0.35rem 0.3rem;
        text-align: center;
        h2{
            display: inline-block;
            border-radius: 0.5rem;
            background: #2960bc;
            padding: 0 1.7rem;
            color: #fff;
            font-weight: bold;
            font-size: 0.5rem;
            line-height: 1.8;
            margin-bottom: 0.3rem;
        }
        .update-time{
            font-size: 0.38rem;
            color: #c6423d;
            margin-bottom: 0.3rem;
        }
        .sink-state{
            overflow: hidden;
            li{
                width: 20%;
                float: left;
                .num{
                    font-size: 0.52rem;
                    font-weight: bold;
                }
                .s1{
                    color: #e7462b;
                }
                .s2{
                    color: #ec7d2c;
                }
                .s3{
                    color: #8b5348;
                }
                .s4{
                    color: #43a28f;
                }
                .s5{
                    color: #3f4f71;
                }
                .state{
                    padding: 0.03rem 0.2rem;
                    font-size: 0.32rem;
                    color: #3b3b3b;
                    background: #f0f5fd;
                    display: inline-block;
                    border-radius: 0.3rem;
                }
            }
        }
        .detail{
            padding-bottom: 0.4rem;
            border-bottom: 1px solid #eaeaea;
            a{
                font-size: 0.32rem;
                color: #333;
            }
        }
    }    
</style>   